export default "__VITE_ASSET__DMbcBMLF__"